
import { configureStore, createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  isAuthenticated: boolean;
  user: string | null;
}

const getStoredAuthUser = (): string | null => {
  const hasToken =
    Boolean(localStorage.getItem('authToken') || sessionStorage.getItem('authToken')) ||
    Boolean(localStorage.getItem('oauth_tokens') || sessionStorage.getItem('oauth_tokens'));

  if (!hasToken) {
    return null;
  }

  return localStorage.getItem('authUser') || sessionStorage.getItem('authUser');
};

const initialAuthState: AuthState = {
  isAuthenticated: Boolean(getStoredAuthUser()),
  user: getStoredAuthUser(),
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialAuthState,
  reducers: {
    login: (state, action: PayloadAction<string>) => {
      state.isAuthenticated = action.payload !== '';
      state.user = action.payload;
    },
    logout: state => {
      state.isAuthenticated = false;
      state.user = null;
      localStorage.removeItem('authToken');
      localStorage.removeItem('oauth_tokens');
      localStorage.removeItem('authUser');
      sessionStorage.removeItem('authToken');
      sessionStorage.removeItem('oauth_tokens');
      sessionStorage.removeItem('authUser');
    },
  },
});

export const { login, logout } = authSlice.actions;

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
